<mat-card @rollDownUp class="b2c-card" id="b2c-card" tabindex="0">
  <img mat-card-image [src]="b2cCardImg" alt="Benefit Detail Card" />
  <div class="b2c-card-content">
    <div class="benefit-provider">
      Congratulations! Here are the benefits provided by your employer,
      <div class="company-name">
        {{ companyName }}
      </div>
    </div>
    <div class="benefit-description">
      {{ contractDescription }}
    </div>
  </div>
</mat-card>
